import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { AuthService } from '@api';



@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {


    //run loading
    const token = this.auth.token;
    if (token) {

        request = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token,
            // 'Content-Type' : 'application/json'
          },
        });
      }


    return next.handle(request).pipe(
      finalize(()=>{
      
        //end loading
      })
    )


  }
}
